export default __webpack_public_path__ + "static/media/Our-Services-1024x474.c45489f1.jpg";